import { z } from 'zod';

/** Het object zoals de API het stuurt (`Inspections\PropertyResource`). */
export const propertyResourceSchema = z.object({
    uuid: z.string(),
    bag_id: z.string().nullable(),
    postcode: z.string(),
    street: z.string(),
    house_number: z.string(),
    house_number_suffix: z.string().nullable(),
    city: z.string(),
    full_address: z.string(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    build_year: z.number().nullable(),
    floor_area: z.number().nullable(),
    property_type: z.string().nullable(),
    property_type_label: z.string().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable(),
});

export type PropertyResource = z.infer<typeof propertyResourceSchema>;

/**
 * Eén adres uit `GET /properties/lookup` (`Inspections\PropertyLookupResource`):
 * het adres uit de BAG met oppervlakte, gebruiksdoel, bouwjaar en status, of het
 * object dat dit bedrijf al heeft (`property_uuid`).
 */
export const propertyCandidateResourceSchema = z.object({
    property_uuid: z.string().nullable(),
    postcode: z.string(),
    street: z.string().nullable(),
    house_number: z.string(),
    house_number_suffix: z.string().nullable(),
    house_number_label: z.string(),
    city: z.string().nullable(),
    full_address: z.string().nullable(),
    bag_id: z.string().nullable(),
    bag_object_id: z.string().nullable(),
    bag_building_ids: z.array(z.string()),
    build_year: z.number().nullable(),
    floor_area: z.number().nullable(),
    usage_purposes: z.array(z.string()),
    usage_purpose_labels: z.array(z.string()),
    bag_status: z.string().nullable(),
    property_type: z.string().nullable(),
    property_type_label: z.string().nullable(),
    latitude: z.number().nullable(),
    longitude: z.number().nullable(),
    source: z.enum(['bag', 'cache', 'known_property']),
});

/**
 * Het hele antwoord: altijd 200. `found` zegt of er adressen zijn, `complete` of
 * de BAG (helemaal) antwoordde, `suffix_matched` of de gevraagde toevoeging op
 * dit nummer bestaat.
 */
export const propertyLookupEnvelopeSchema = z.object({
    data: z.array(propertyCandidateResourceSchema),
    meta: z.object({
        found: z.boolean(),
        complete: z.boolean(),
        suffix_matched: z.boolean(),
        message: z.string().nullable(),
    }),
});

export type PropertyCandidateResource = z.infer<typeof propertyCandidateResourceSchema>;
export type PropertyLookupEnvelope = z.infer<typeof propertyLookupEnvelopeSchema>;
